import { Navigate } from "react-router-dom";
import { getSavedToken, isTokenExpired } from "../utils/tokenHelper";

export default function PublicRoute({ children }) {
  const tokenData = getSavedToken();

  const isLoggedIn =
    localStorage.getItem("isLoggedIn") === "true" &&
    tokenData &&
    tokenData.access_token &&
    !isTokenExpired(tokenData);

  return !isLoggedIn ? children : <Navigate to="/home" replace />;
}